import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Intro() {
    return (
        <OnboardingBody title='Nutshell’s powerful prospecting tool'>
            <p>Track which companies are visiting your website before they submit a form.</p>
            <p>
                This data can help your team prioritize outbound calls, tailor sales pitches, and
                optimize a strategy for turning prospects into sales.
            </p>
        </OnboardingBody>
    );
}
